export type InboxAccessView = 'allowed' | 'denied' | 'checking' | 'failed'

/**
 * What the inbox page shows for `canAccessFeedbackInbox`.
 *
 * `null` means "not known", and the session store cannot say why: the
 * `/authorization/me` request may be in flight or may have failed (RequireAuth
 * deliberately leaves it null on failure). Treating both as "loading" is a
 * skeleton forever, so the page re-asks and this maps that request's state:
 * still going is `checking`, failed is `failed` (error with a retry), and only
 * a confirmed `false` is `denied`.
 */
export function inboxAccessView(
  canAccess: boolean | null,
  check: { isError: boolean },
): InboxAccessView {
  if (canAccess === true) return 'allowed'
  if (canAccess === false) return 'denied'
  return check.isError ? 'failed' : 'checking'
}
